<script>
    export let x
    export let y
    export let fill
    export let text
    export let fontSize
    export let textAnchor
    export let lineLabel

    let dx = 1
    let dy = 24
    $: angle = Math.atan(dy/dx)
    $: dxCircle = dx >= 0 ? Math.cos(angle) * 12 : -Math.cos(angle) * 12
    $: dyCircle = dx >= 0 ? Math.sin(angle) * 12 : -Math.sin(angle) * 12
    let moving = false

    function start() {
		moving = true;
	}
	
	function stop() {
		moving = false;
	}
	
	function move(e) {
			if (moving) {
				dx += e.movementX;
				dy += e.movementY;
      }
	}
</script>

<svelte:window on:mouseup={stop} on:mousemove={move}  />

<text on:mousedown={start} x={lineLabel ? x + 3 : x} y={lineLabel ? y - 20: y} {dx} {dy} {fill} font-size={fontSize} text-anchor={textAnchor}>{text}</text>
<line 
  x1={lineLabel ? x : x + dxCircle}
  x2={x + dx}
  y1={lineLabel ? y : y + dyCircle}
  y2={lineLabel ? y -24 + dy : dy < 0 ? y + dy + 4 : y + dy - 10}
  stroke-width={3}
  stroke={"#ffffff"}></line>
<line 
  x1={lineLabel ? x : x + dxCircle}
  x2={x + dx}
  y1={lineLabel ? y :y + dyCircle}
  y2={lineLabel ? y -24 + dy : dy < 0 ? y + dy + 4 : y +dy-10}
  stroke-width={lineLabel ? 1 : 1.5}
  stroke={fill}
  stroke-dasharray={lineLabel ? "3 3" : "none" }></line>
<style>
    text {
        user-select: none;
		cursor: move;
      text-shadow: -1px -1px white, -1px 1px white, 1px 1px white, 1px -1px white,
        -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;
    }
  </style>